const CORRECTION_REQUESTS = {
  curp: 'curp',
  identification: 'identification',
  w8Contract: 'w8_contract'
};

export default CORRECTION_REQUESTS;
